export default {

  APP_DATA: 'APP_DATA',
  APP_DATA_FAILED: 'APP_DATA_FAILED',
  APP_DATA_FINISHED: 'APP_DATA_FINISHED',
  LOGOUT: 'LOGOUT',
}
